import React from "react";
import "./ContentGrid.css";

type ContentGridProps = {
  gridGap: string;
  className?: string;
  children: React.ReactNode;
};

export const ContentGrid: React.FC<ContentGridProps> = (props) => {
  return (
    <div className={`content-grid-area ${props.className ? props.className : ""}`} style={{ gridGap: props.gridGap }}>
      {props.children}
    </div>
  );
};
